module.exports = __webpack_public_path__ + "static/media/seedskecil.32c3cad2.png";